import { useMediaQueries } from 'hooks';

const Desktop = ({ children }) => {
  const { isDesktopOrGreater } = useMediaQueries();

  return isDesktopOrGreater ? children : null;
};

export default Desktop;
